import { cookieGet, cookieSet } from './cookies';
import { v4 as uuidv4 } from 'uuid';

export const isServer = typeof window === 'undefined';
export const isClient = typeof window !== 'undefined';

export const getDeviceId = async () => {
  const deviceIdCacheKey = 'device_id';
  const MINUTES_IN_NINETY_DAYS = 90 * 24 * 60;
  let deviceId = await cookieGet(deviceIdCacheKey, undefined);
  if (!deviceId) {
    deviceId = cookieSet(deviceIdCacheKey, uuidv4(), MINUTES_IN_NINETY_DAYS);
  }
  return deviceId;
};

/**
 * Returns the full name of a user given first and last name.
 * Handles missing/null/undefined values gracefully.
 */
export function getUserFullName(user: { firstName?: string | null; lastName?: string | null } | null | undefined): string {
  if (!user) return '';
  const first = user.firstName?.trim() || '';
  const last = user.lastName?.trim() || '';
  return [first, last].filter(Boolean).join(' ');
}
